import callApi from 'helpers/callApi';

// callApi({ url: '/teachers', query: params });

export const getOrderItems = (params) => callApi({ url: '/order-items', query: params });
export const getOrderItemById = (id) => callApi({ url: `/order-items/${id}` });
export const getAllOrderItems = (params) => callApi({ url: '/order-items', query: { ...params, limit: 10000, page: 1 } });
export const getUserOrderItems = (id, params) => callApi({ url: `/users/${id}/order-items`, query: params });
export const getReceiptVouchers = (params) => callApi({ url: '/orders/receipt-vouchers', query: params });
export const getAllReceiptVouchers = (params) => callApi({ url: '/orders/receipt-vouchers', query: { ...params, limit: 10000, page: 1 } });

// export const refundOrder = (id) => callApi({ url: `/orders/${id}/refund`, method: 'post' });

export const editOrderItemById = (id, data) => callApi({ url: `/order-items/${id}`, body: data, method: 'put' });
// export const deleteOrderById = (id) => deleteOrderLoader.delete(`/orders/${id}`);
